module.exports = __webpack_public_path__ + "img/Open.2c401e7f.png";